var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.lock",
          value: _vm.formSubmitFlag,
          expression: "formSubmitFlag",
          modifiers: { lock: true }
        }
      ],
      staticClass: "importPage",
      attrs: { "element-loading-text": "数据导入中..." }
    },
    [
      _c("ul", [
        _c("li", [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "down-right" }, [
            _c("div", { staticClass: "gray-bg" }, [_vm._v("1. 下载模板")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "down-layout" },
              [
                _c("span", { staticClass: "down-text" }, [
                  _vm._v("点击下载导入模板")
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "min-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.openDownHref($event)
                      }
                    }
                  },
                  [_vm._v("下载")]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "down-right" }, [
            _c("div", { staticClass: "gray-bg" }, [
              _vm._v("2. 选择需要导入的Excel文件")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "down-layout" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      enctype: "multipart/form-data",
                      id: "importScoreForm"
                    }
                  },
                  [
                    _c("div", { staticClass: "down-check-files" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filename,
                            expression: "filename"
                          }
                        ],
                        attrs: {
                          type: "text",
                          name: "textfield",
                          id: "textfield"
                        },
                        domProps: { value: _vm.filename },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.filename = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "select-btn",
                        attrs: { type: "button", value: "选择文件" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "upload-demo",
                        attrs: {
                          name: "file",
                          id: "excelWrap",
                          accept: ".xls,.xlsx,.csv",
                          type: "file"
                        },
                        on: { change: _vm.fileChange }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "min-btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.submitForm($event)
                          }
                        }
                      },
                      [_vm._v("导入")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _vm.configVo.type == "student"
          ? _c("li", [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "down-right" }, [
                _c("div", { staticClass: "gray-bg" }, [
                  _vm._v("3. 导入信息确认")
                ]),
                _vm._v(" "),
                _vm.showConfirm
                  ? _c("div", { staticClass: "down-layout" }, [
                      _vm.importResult.errorMsgList &&
                      _vm.importResult.errorMsgList.length > 0
                        ? _c("div", { staticClass: "new-import-text-tip" }, [
                            _c("span", { staticClass: "font-big font-err" }, [
                              _vm._v("导入失败！")
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "请按下面的“信息问题提示”在Excel中修正错误信息后再重新导入。"
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.importResult.errorMsgList &&
                      _vm.importResult.errorMsgList.length > 0
                        ? _c("div", { staticClass: "has-error" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  "border-left": "2px solid #00b3ee",
                                  "padding-left": "10px",
                                  margin: "20px 0"
                                }
                              },
                              [_vm._v("信息问题提示")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "err-message-list" },
                              [
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.importResult.errorMsgList,
                                      "tooltip-effect": "dark"
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "index",
                                        label: "出错位置"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "message",
                                        label: "问题描述"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showTableList
                        ? _c("div", { staticClass: "new-import-text-tip" }, [
                            _c("span", { staticClass: "font-big font-err" }, [
                              _vm._v("导入失败！")
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "请确认列表中学生的”学籍号“、”姓名“是否完全正确？"
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showTableList
                        ? _c("div", { staticClass: "table-wrap" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  "border-left": "2px solid #00b3ee",
                                  "padding-left": "10px",
                                  margin: "10px 0"
                                }
                              },
                              [_vm._v("信息问题提示")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "new-student-list" },
                              [
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.studentTableList,
                                      "tooltip-effect": "dark"
                                    }
                                  },
                                  _vm._l(
                                    _vm.importResult.tableData.headerList,
                                    function(item, index) {
                                      return _c("el-table-column", {
                                        key: index,
                                        attrs: { label: item },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(scope) {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      style: {
                                                        color:
                                                          scope.row[
                                                            _vm.propsMap[item]
                                                          ].passed == false
                                                            ? "red"
                                                            : ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row[
                                                            _vm.propsMap[item]
                                                          ].value
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._m(3),
                            _vm._v(" "),
                            _vm.studentTableTotal > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "page-wrap",
                                    staticStyle: {
                                      "text-align": "center",
                                      "margin-top": "20px"
                                    }
                                  },
                                  [
                                    _c("el-pagination", {
                                      attrs: {
                                        small: "",
                                        background: "",
                                        total: _vm.studentTableTotal,
                                        "current-page": _vm.studentTableCurrent,
                                        "page-size": _vm.studentTablePageSize,
                                        layout: "prev, pager, next"
                                      },
                                      on: {
                                        "current-change": _vm.pageNumChange
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showBtn &&
                            (_vm.importResult.tableData.data.length > 0 ||
                              _vm.importResult.errorMsgList.length > 0)
                              ? _c(
                                  "div",
                                  { staticClass: "import-btn-wrap" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "",
                                          disabled:
                                            _vm.importResult.failureNum != 0
                                        },
                                        on: { click: _vm.handleImportStudent }
                                      },
                                      [_vm._v("全部导入")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "small", type: "" },
                                        on: { click: _vm.cancelImport }
                                      },
                                      [_vm._v("取消导入")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.importResult.errorMsgList.length == 0 &&
                        _vm.importResult.tableData.data.length == 0) ||
                      _vm.hasSuccess
                        ? _c("div", { staticClass: "new-import-text-tip" }, [
                            _vm._v("\n            本次导入学生总数"),
                            _c(
                              "span",
                              { staticClass: "font-big font-success" },
                              [_vm._v(_vm._s(_vm.importResult.totalNum))]
                            ),
                            _vm._v("人\n          ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.importResult.errorMsgList.length == 0 &&
                      _vm.importResult.tableData.data.length == 0
                        ? _c("div", { staticClass: "no-table-success" }, [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("哇！太棒了，学生信息已经全部导入成功了！")
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasSuccess
                        ? _c("div", { staticClass: "no-table-success" }, [
                            _vm._m(5),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("哇！太棒了，学生信息已经全部导入成功了！")
                            ])
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errorList.length > 0,
                expression: "errorList.length > 0"
              }
            ],
            staticClass: "err-tip",
            attrs: { id: "errorList" }
          },
          [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "down-right" }, [
              _c("div", { staticClass: "gray-bg" }, [_vm._v("3. 错误提示")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "down-layout " },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.errorList, "tooltip-effect": "dark" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "问题文档", width: "220" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "index", label: "出错位置" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "message", label: "问题描述" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "css-total" }, [
                    _vm._v("共计： " + _vm._s(_vm.errorList.length) + "条")
                  ])
                ],
                1
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "down-left" }, [
      _c("div", { staticClass: "down-circle" }, [
        _c("i", { staticClass: "el-icon-download" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "down-left" }, [
      _c("div", { staticClass: "down-circle" }, [
        _c("i", { staticClass: "el-icon-tickets" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "down-left" }, [
      _c("div", { staticClass: "down-circle" }, [
        _c("i", { staticClass: "el-icon-tickets" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { margin: "20px 0", "font-size": "14px" } },
      [
        _c("span", {
          staticClass: "icon-attention",
          staticStyle: { "padding-right": "10px", color: "#ff9900" }
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "信息正确无误，点击“全部导入”按钮，直接导入即可，否则点击“取消导入”按钮，并在Excel文件中纠正后重新导入。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "success-circle" }, [
      _c("span", { staticClass: "icon-code-finished success-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "success-circle" }, [
      _c("span", { staticClass: "icon-code-finished success-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "down-left" }, [
      _c("i", { staticClass: "el-icon-warning" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }